import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocInitialPetition(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.458 99.615C13.13 99.615 8 94.485 8 88.157h57.288c0 6.328 5.13 11.458 11.457 11.458H19.458Z"
        fill="#E2E8F0"
      />
      <path
        d="M76.745 99.615c6.328 0 11.458-5.13 11.458-11.458V19.412H30.915v68.745c0 6.328-5.13 11.458-11.457 11.458h57.287Z"
        fill="#F1F5F9"
      />
      <path
        d="M31.715 88.157c0 6.77-5.488 12.258-12.258 12.258a.801.801 0 0 1 0-1.6c5.886 0 10.658-4.772 10.658-10.658a.8.8 0 0 1 1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M68.152 81.629a.8.8 0 1 1 0 1.6H39.508a.8.8 0 1 1 0-1.6h28.644Zm4.583-5.729a.8.8 0 1 1 0 1.6H39.508a.8.8 0 1 1 0-1.6h33.227Zm6.875-5.73a.8.8 0 0 1 0 1.601H39.508a.8.8 0 0 1 0-1.6H79.61Zm0-5.728a.8.8 0 0 1 0 1.6H39.508a.8.8 0 0 1 0-1.6H79.61Zm0-5.728a.8.8 0 0 1 0 1.6H39.508a.8.8 0 1 1 0-1.6H79.61Zm-17.187-5.729a.8.8 0 1 1 0 1.6H39.508a.8.8 0 0 1 0-1.6h22.915Zm0-5.73a.8.8 0 0 1 0 1.601H39.508a.8.8 0 0 1 0-1.6h22.915Zm0-5.728a.8.8 0 0 1 0 1.6H39.508a.8.8 0 1 1 0-1.6h22.915Zm0-5.729a.8.8 0 1 1 0 1.6H39.508a.8.8 0 1 1 0-1.6h22.915Z"
        fill="#B3C0D0"
      />
      <path d="M79.61 36.598H68.152v17.187H79.61V36.598Z" fill="#A6DBCB" />
      <path
        d="M79.61 35.798a.8.8 0 0 1 .8.8v17.187a.8.8 0 0 1-.8.8H68.152a.8.8 0 0 1-.8-.8V36.598a.8.8 0 0 1 .8-.8H79.61ZM68.952 52.986h9.857V37.398h-9.857v15.587Z"
        fill="#A6DBCB"
      />
      <path
        d="M108.863 41.263c-4.475-4.475-11.73-4.475-16.204 0l-15.22 15.22a17.187 17.187 0 0 0-5.034 12.153v9.084h9.085c4.558 0 8.93-1.81 12.152-5.034l15.221-15.22c4.474-4.474 4.474-11.729 0-16.203Z"
        fill="#599F40"
      />
      <path
        d="M84.558 49.364v16.204h16.203l8.102-8.102c4.474-4.474 4.474-11.729 0-16.203-4.475-4.475-11.73-4.475-16.204 0l-8.101 8.101Z"
        fill="#78B441"
      />
      <path
        d="M98.33 64.768a.8.8 0 0 1 0 1.6H84.558a.8.8 0 0 1 0-1.6H98.33ZM88.61 46.944a.8.8 0 0 1 .8.8v13.773a.8.8 0 0 1-1.6 0V47.744a.8.8 0 0 1 .8-.8Z"
        fill="#00664F"
      />
      <path
        d="M109.673 52.616a.8.8 0 1 1 0 1.599H95.91V40.453a.8.8 0 1 1 1.6 0v12.163h12.163Zm-9.478-3.817 6.887-6.887a.8.8 0 1 1 1.131 1.132l-6.887 6.886a.8.8 0 0 1-1.131-1.13Z"
        fill="#599F40"
      />
      <path
        d="m68.387 80.184 31.597-31.597a1.1 1.1 0 1 1 1.555 1.555L69.942 81.739a1.1 1.1 0 1 1-1.555-1.555Z"
        fill="#0F172A"
      />
      <path
        d="m67.542 80.345-.004 2.23 2.23-.003a3.445 3.445 0 0 0 3.438-3.438l.003-2.23-2.23.004a3.445 3.445 0 0 0-3.437 3.437Z"
        fill="#0F172A"
      />
      <path
        d="M73.633 76.48a.6.6 0 0 1 .176.425l-.004 2.23a4.045 4.045 0 0 1-4.036 4.037l-2.23.004a.6.6 0 0 1-.601-.601l.003-2.231a4.046 4.046 0 0 1 4.037-4.036l2.23-.004.118.011a.6.6 0 0 1 .307.165Zm-2.653 1.028a2.845 2.845 0 0 0-2.838 2.838l-.003 1.628 1.629-.003a2.845 2.845 0 0 0 2.838-2.838l.003-1.628-1.629.003Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocInitialPetition)
